import React from 'react';
import logo from './logo.svg';
import './App.css';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>Redirecting...</p>
        </header>
      </div>
    );
  }

  componentDidMount() {
    const target = process.env.REACT_APP_URL
    const path = window.location.pathname
    const authToken = localStorage.getItem('authToken')
    
    const goTo = `${target}${path}${authToken ? `?authToken=${authToken}` : ''}`

    window.location.replace(goTo);
  }
}

export default App;
